import type { SxProps, Theme } from '@mui/material/styles';
import BasicSnackBar from './BasicSnackBar';
import { useProgramStateNotification, type ProgramNotificationType } from '../../hooks/ui/useProgramStateNotification';

export const getProgramStateSnackbarContentSx = (type: ProgramNotificationType): SxProps<Theme> | undefined => {
  if (type === 'deploying' || type === 'deployed') {
    return (theme) => ({
      backgroundColor: theme.vars?.palette?.chart?.blue ?? theme.palette.chart.blue,
      color: theme.vars?.palette?.common?.black ?? theme.palette.common.black,
    });
  }

  if (type === 'running' || type === 'stopped') {
    return (theme) => ({
      backgroundColor: theme.vars?.palette?.chart?.green ?? theme.palette.chart.green,
      color: theme.vars?.palette?.common?.black ?? theme.palette.common.black,
    });
  }

  return undefined;
};

/**
 * Renders the program deploy/run/stop status snackbar at the app root.
 * Placed at App level so it persists across all pages/tabs.
 */
const ProgramStateSnackbar = () => {
  const programNotification = useProgramStateNotification();

  return (
    <BasicSnackBar
      message={programNotification.message}
      vertical="bottom"
      horizontal="left"
      open={programNotification.open}
      onClose={programNotification.onClose}
      onExited={programNotification.onExited}
      persistent={programNotification.persistent}
      contentSx={getProgramStateSnackbarContentSx(programNotification.type)}
    />
  );
};

export default ProgramStateSnackbar;
